import { useEffect, useState } from 'react';
import { ApiStatus, getApiStatus } from '../services/systemApi';

export function useTradingStatus() {
  const [status, setStatus] = useState<ApiStatus | null>(null);

  useEffect(() => {
    let mounted = true;
    getApiStatus()
      .then((data) => {
        if (mounted) setStatus(data);
      })
      .catch(() => {
        if (mounted) setStatus(null);
      });
    return () => {
      mounted = false;
    };
  }, []);

  return status;
}
